import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { navigateTo } from "../../../../utils/commonFunctions"
import { useMemo } from "react"

const useNavigation = () => {
    const params = useParams()
    const navigate = useNavigate() // Assume useNavigateFunction is imported from a routing library
    const { mission_name, mission_id } = params as { mission_name: string, mission_id: string }
    const [searchParams] = useSearchParams();

    // 🔹 Get values
    const type = useMemo(() => searchParams.get('type'), [searchParams.get('type')]);
    const step = useMemo(() => searchParams.get('step'), [searchParams.get('step')]);
    const scenarioId = useMemo(() => searchParams.get('scenarioId'), [searchParams.get('scenarioId')]);

    const resetViewerMode = () => {
        const previous_map_details = JSON.parse(sessionStorage.getItem('map_details') || '{}');
        const viewerDetails = previous_map_details?.[scenarioId!];
        if (viewerDetails) {
            const updatedMapDetails = {
                ...previous_map_details,
                [scenarioId!]: {
                    ...viewerDetails,
                    View: '2D',
                },
            };
            sessionStorage.setItem("map_details", JSON.stringify(updatedMapDetails));
        }
    }

    const closeScenario = (page?: 'Home' | 'Dashboard') => {
        const updatedPage = page || 'Dashboard'
        resetViewerMode()
        switch (updatedPage) {
            case 'Home':
                navigateTo(``, navigate)
                break;
            case 'Dashboard':
                navigateTo(`${mission_name}/${mission_id}/simulate`, navigate)
                break;
            default:
                break;
        }
    }

    const getQueryParam = (key: string): string | null => {
        return new URLSearchParams(window.location.search).get(key);
    };

    return {
        type,
        step,
        navigate,
        missionId: mission_id,
        scenarioId,
        closeScenario,
        getQueryParam,
        resetViewerMode
    }
}
export default useNavigation